import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IBlockForm } from '../../../../models/blocks/block-form.interface';

@Component({
  selector: 'empathy-group-block-form',
  templateUrl: 'group-block-form.component.html',
  styleUrls: ['./group-block-form.component.scss']
})
export class GroupBlockFormComponent {
  activeBlock = input.required<FormGroup<IBlockForm>>();
  isSecondChild = input<boolean>(false);
}
